"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentListingWrapper$ = exports.AgentListingWrapper$outboundSchema = exports.AgentListingWrapper$inboundSchema = void 0;
exports.agentListingWrapperToJSON = agentListingWrapperToJSON;
exports.agentListingWrapperFromJSON = agentListingWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const areapropertylisting_js_1 = require("./areapropertylisting.js");
/** @internal */
exports.AgentListingWrapper$inboundSchema = z.object({
    attributes: areapropertylisting_js_1.AreaPropertyListing$inboundSchema,
    id: z.string(),
});
/** @internal */
exports.AgentListingWrapper$outboundSchema = z.object({
    attributes: areapropertylisting_js_1.AreaPropertyListing$outboundSchema,
    id: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AgentListingWrapper$;
(function (AgentListingWrapper$) {
    /** @deprecated use `AgentListingWrapper$inboundSchema` instead. */
    AgentListingWrapper$.inboundSchema = exports.AgentListingWrapper$inboundSchema;
    /** @deprecated use `AgentListingWrapper$outboundSchema` instead. */
    AgentListingWrapper$.outboundSchema = exports.AgentListingWrapper$outboundSchema;
})(AgentListingWrapper$ || (exports.AgentListingWrapper$ = AgentListingWrapper$ = {}));
function agentListingWrapperToJSON(agentListingWrapper) {
    return JSON.stringify(exports.AgentListingWrapper$outboundSchema.parse(agentListingWrapper));
}
function agentListingWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AgentListingWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AgentListingWrapper' from JSON`);
}
//# sourceMappingURL=agentlistingwrapper.js.map